var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacy(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.233 24.51a2.622 2.622 0 00-3.707 0l-3.805 3.804a.655.655 0 01-1.12-.464V8.382a2.717 2.717 0 00-2.182-2.725 2.622 2.622 0 00-3.06 2.584v9.828a.656.656 0 01-1.31 0V5.761a2.717 2.717 0 00-2.18-2.725 2.623 2.623 0 00-3.059 2.585V18.07a.655.655 0 01-1.31 0V8.382a2.717 2.717 0 00-2.18-2.725 2.622 2.622 0 00-3.062 2.584v9.828a.655.655 0 01-1.31 0V11a2.72 2.72 0 00-2.18-2.725 2.623 2.623 0 00-3.062 2.585v19.657A10.483 10.483 0 0018.19 41h4.83a13.1 13.1 0 009.266-3.838l8.948-8.948a2.62 2.62 0 000-3.705z",
    fill: "#A6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.141 13c5.16 0 11.042 2.519 17.25 9.9.808.955.815 2.352.017 3.315-2.905 3.458-9.293 9.924-17.545 9.924-5.15 0-11.042-2.522-17.25-9.9a2.582 2.582 0 01-.013-3.316C5.5 19.465 11.89 13 20.141 13zm-8.02 4.961a30.942 30.942 0 00-7.558 6.62 29.753 29.753 0 007.751 6.8 10.258 10.258 0 01-.193-13.42zm7.88 14.319a7.712 7.712 0 110-15.424 7.712 7.712 0 010 15.424zm7.685-14.524a10.256 10.256 0 01.193 13.419 30.943 30.943 0 007.558-6.619 29.766 29.766 0 00-7.75-6.8z",
    fill: "#0D4599"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.856 24.568A3.856 3.856 0 1120 20.712c.388 0 .774.061 1.144.18A1.9 1.9 0 0020 22.64a1.925 1.925 0 001.928 1.928 1.9 1.9 0 001.748-1.144c.12.37.18.756.18 1.144z",
    fill: "#F2A619"
  })));
}

export default __webpack_public_path__ + "e7aefe45e0b2828617b6962c41c10ec2.svg";
export { SvgPrivacy as ReactComponent };